<template>
   <div>
      <h1 style="font-size: 24px; color: black;">亲密关系日报</h1>
      <div class="block" style="margin-top: 25px" >
         <span class="demonstration">日期：</span>
         <el-date-picker
                 v-model="queryData.timeDate"
                 type="daterange"
                 :clearable="false"
                 range-separator="至"
                 start-placeholder="开始日期"
                 end-placeholder="结束日期"
                 value-format="yyyy-MM-dd">
         </el-date-picker>&emsp;&emsp;
         <el-button  type="primary" class="margin-left-10"  @click="query" >查询</el-button>
      </div>

      <h1>
         <el-table border :data="closeReport"
                   :header-cell-style="{background:'#282828'}">
            <el-table-column prop="dt"  label="日期" align="center"></el-table-column>
            <el-table-column prop="clickButtonTimes"  label="点击邀请按钮次数" align="center"></el-table-column>
            <el-table-column prop="enough500Coin"  label="红包币满足500次数" align="center"></el-table-column>
            <el-table-column prop="enoughCoinRate"  label="红包币满足率" align="center">
               <template slot-scope="scope">
                  {{scope.row.enoughCoinRate==null?'0.00%':(scope.row.enoughCoinRate*100).toFixed(2)+'%'}}
               </template>
            </el-table-column>
            <el-table-column prop="closeSendTimes"  label="亲密关系发起总次数" align="center"></el-table-column>
            <el-table-column prop="closeBuildTimes"  label="亲密关系建立总次数" align="center"></el-table-column>
            <el-table-column prop="closeBuildRate"  label="亲密关系建成率" align="center">
               <template slot-scope="scope">
                  {{scope.row.closeBuildRate==null?'0.00%':(scope.row.closeBuildRate*100).toFixed(2)+'%'}}
               </template>
            </el-table-column>
            <el-table-column prop="cpSendTimes"  label="cp申请次数" align="center"></el-table-column>
            <el-table-column prop="cpBuildTimes"  label="cp建立次数" align="center"></el-table-column>
            <el-table-column prop="bfSendTimes"  label="闺蜜申请次数" align="center"></el-table-column>
            <el-table-column prop="bfBuildTimes"  label="闺蜜建立次数" align="center"></el-table-column>
            <el-table-column prop="sbSendTimes"  label="死党申请次数" align="center"></el-table-column>
            <el-table-column prop="sbBuildTimes"  label="死党建立次数" align="center"></el-table-column>

         </el-table>
         <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[10,20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
            </el-pagination>
         </el-row>
      </h1>
   </div>
</template>

<script>
   import {
      searchCloseReport
   }from "@/http/api";
   import utils from '@/utils'
    export default {
        name: "CloseReport",
       data(){
           return{
              closeReport:[],
              queryData:{
                 timeDate:['',''],
              },
              queryTrueData:{
                 order:'descending',
                 prop:'dt',
                 startTime:'',
                 endTime:'',
              },
              queryInfo:{
                 pagesize:10,
                 pagenum:1,
                 total:0,
              },
           }
       },
       methods:{
          handleSizeChange(newSize){
             this.queryInfo.pagesize=newSize;
             this.searchCloseReport();
          },
          query(){
             this.queryInfo.pagenum=1;
             this.searchCloseReport();
          },
          handleCurrentChange(newPage){
             this.queryInfo.pagenum=newPage;
             this.searchCloseReport();
          },
          searchCloseReport(){
             if (this.queryData.timeDate===null){
                this.queryData.timeDate=['',''];
             }
             this.queryTrueData.startTime= this.queryData.timeDate[0];
             this.queryTrueData.endTime=this.queryData.timeDate[1];
             this.queryTrueData.size=this.queryInfo.pagesize;
             this.queryTrueData.page=this.queryInfo.pagenum;
             searchCloseReport(this.queryTrueData).then(resp=>{
                this.closeReport=resp.data.info.content;
                this.queryInfo.total=resp.data.info.totalElements;
             });
          },
       },
       created(){
          this.queryData.timeDate=[utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
          this.searchCloseReport();
       }
    }
</script>

<style scoped>

</style>
